import { ChargeTypeRepoImpl } from "domain/repository/ChargeType/ChargeTypeRepoImpl";
import { CompanyRepoImpl } from "domain/repository/Company/CompanyRepoImpl";
import { MasterHoldRepoImpl } from "domain/repository/MasterHold/MasterHoldRepoImpl";
import { ParameterDetailRepoImpl } from "domain/repository/parameter/ParameterDetailRepoImpl";
import { SpecialHandlingIndMappingRepoImpl } from "domain/repository/SpecialHanldingInd/SpecialHandlingIndMappingRepoImpl";
import { StandardTariffCodeRepoImpl } from "domain/repository/TariffCode/StandardTariffCodeRepoImpl";
import { TariffTypeRepoImpl } from "domain/repository/TariffCode/TariffTypeRepoImpl";
import { useMasterHoldMaintenanceTracked } from "presentation/store/MasterHold/MasterHoldMaintenanceProvider";
import { MasterHoldMaintenanceVM } from "presentation/viewModel/MasterHold/MasterHoldMaintenanceVM";
import { useMemo } from "react";

export const useMasterHoldMaintenanceVM = () => {
    const [, setMasterHoldMaintenanceState] = useMasterHoldMaintenanceTracked();
    const masterHoldMainVM = useMemo(() =>
        MasterHoldMaintenanceVM({
            dispatch: [setMasterHoldMaintenanceState],
            repo: MasterHoldRepoImpl(),
            companyRepo: CompanyRepoImpl(),
            chargeTypeRepo: ChargeTypeRepoImpl(),
            standardTariffCodeRepo: StandardTariffCodeRepoImpl(),
            parameterDetailRepo: ParameterDetailRepoImpl(),
            tariffTypeRepo: TariffTypeRepoImpl(),
            specialhandlingIndMappingRepo: SpecialHandlingIndMappingRepoImpl(),
        }), [setMasterHoldMaintenanceState])

    return masterHoldMainVM
}

